export default "__VITE_ASSET__qkqlkbOl__"